@if (serverDown$ | async) {
    <div class="server-down --visible">
        <div class="server-down__card">
            <img alt="JeriCommerce" class="server-down__card__icon" src="assets/images/icon-primary.svg" />

            <h2 class="server-down__card__title --l" [innerHTML]="'SERVER_DOWN.title' | translate"></h2>
            <p class="server-down__card__description --paragraph" [innerHTML]="'SERVER_DOWN.description' | translate"></p>

            <div class="server-down__card__status">
                <span class="server-down__card__status__dot"></span>
                <span class="server-down__card__status__text --xs" [innerHTML]="'SERVER_DOWN.retrying' | translate"></span>
            </div>

            <button class="server-down__card__retry" color="dark" mat-flat-button (click)="retryNow()">
                <span [innerHTML]="'SERVER_DOWN.retry' | translate"></span>
            </button>

            <a
                class="server-down__card__status-link --caption"
                href="https://status.jericommerce.com"
                rel="noopener noreferrer"
                target="_blank"
            >
                <mat-icon class="server-down__card__status-link__icon" svgIcon="app:open_in_new"></mat-icon>
                <span [innerHTML]="'SERVER_DOWN.statusPage' | translate"></span>
            </a>
        </div>
    </div>
}
